import { loadModal } from '../actions/loadModal';

const $ = jQuery;
const SUBSCRIPTION_MODAL_ID = 'growtypeWcSubscriptionModal';
const SUBSCRIPTION_MODAL_HASH = '#subscription';
const SUBSCRIPTION_MODAL_SLIDE_HASH_PREFIX = '#subscription-slide-';

function hasSubscriptionModalHash() {
    const hash = window.location.hash.toLowerCase();
    return hash === SUBSCRIPTION_MODAL_HASH || /^#subscription-slide-\d+$/.test(hash);
}

function getSubscriptionSlideNumberFromHash() {
    const match = window.location.hash.match(/^#subscription-slide-(\d+)$/i);
    if (!match) return null;

    const slideNumber = Number.parseInt(match[1], 10);
    return Number.isInteger(slideNumber) && slideNumber > 0 ? slideNumber : null;
}

function getSubscriptionModalHash(slideNumber = 1) {
    return `${SUBSCRIPTION_MODAL_SLIDE_HASH_PREFIX}${slideNumber}`;
}

function getSubscriptionSliderCurrentSlideNumber($slider) {
    if (!$slider.hasClass('slick-initialized')) return 1;

    return $slider.slick('slickCurrentSlide') + 1;
}

function replaceSubscriptionModalHash(hash = '') {
    const nextUrl = `${window.location.pathname}${window.location.search}${hash}`;
    window.history.replaceState(window.history.state, document.title, nextUrl);
}

function syncSubscriptionSliderWithHash($slider, restoreRequestedSlide = false) {
    if (!$slider.hasClass('slick-initialized') || !$slider[0]?.slick) return;

    const slideCount = $slider.find('.slick-slide:not(.slick-cloned)').length;
    if (!slideCount) return;

    $slider
        .off('afterChange.growtypeChatSubscriptionHash')
        .on('afterChange.growtypeChatSubscriptionHash', function (event, slick, currentSlide) {
            replaceSubscriptionModalHash(getSubscriptionModalHash(currentSlide + 1));
        });

    const requestedSlideNumber = restoreRequestedSlide
        ? getSubscriptionSlideNumberFromHash()
        : null;

    if (requestedSlideNumber !== null) {
        const requestedSlideIndex = Math.min(requestedSlideNumber, slideCount) - 1;
        $slider.slick('slickGoTo', requestedSlideIndex, true);
    }

    const currentSlideNumber = getSubscriptionSliderCurrentSlideNumber($slider);
    replaceSubscriptionModalHash(getSubscriptionModalHash(currentSlideNumber));
}

function syncSubscriptionSliderWhenReady($slider, restoreRequestedSlide = false, attemptsRemaining = 20) {
    if (!$slider.length) return;

    if ($slider.hasClass('slick-initialized') && $slider[0]?.slick) {
        $slider.show();
        $slider.slick('setPosition');
        syncSubscriptionSliderWithHash($slider, restoreRequestedSlide);
        return;
    }

    if (attemptsRemaining <= 0) {
        $slider.show();
        return;
    }

    window.setTimeout(function () {
        syncSubscriptionSliderWhenReady($slider, restoreRequestedSlide, attemptsRemaining - 1);
    }, 50);
}

function showSubscriptionModalFromHash() {
    if (!hasSubscriptionModalHash()) return;

    const action = window.growtype_chat_ajax?.get_subscription_modal_action
        || 'growtype_wc_get_subscription_modal';

    loadModal(action, null, { modalId: SUBSCRIPTION_MODAL_ID })
        .then(function () {
            if (!hasSubscriptionModalHash()) return;

            const modal = document.getElementById(SUBSCRIPTION_MODAL_ID);
            if (!modal) return;

            const $slider = $(modal).find('.growtype-theme-slider');

            if (typeof window.growtypeModal?.show === 'function') {
                window.growtypeModal.show(SUBSCRIPTION_MODAL_ID);
            } else if (window.bootstrap?.Modal) {
                window.bootstrap.Modal.getOrCreateInstance(modal).show();
            }

            syncSubscriptionSliderWhenReady($slider, true);
        })
        .catch(function () {
            // The regular modal triggers remain available if loading fails.
        });
}

export function lockedFeatureModal() {

    $(document).on('shown.bs.modal', `#${SUBSCRIPTION_MODAL_ID}`, function () {
        if (!hasSubscriptionModalHash()) {
            const $slider = $(this).find('.growtype-theme-slider');
            replaceSubscriptionModalHash(
                getSubscriptionModalHash(getSubscriptionSliderCurrentSlideNumber($slider))
            );
        }
    });

    $(document).on('hidden.bs.modal', `#${SUBSCRIPTION_MODAL_ID}`, function () {
        if (hasSubscriptionModalHash()) {
            replaceSubscriptionModalHash();
        }
    });

    $(window)
        .off('hashchange.growtypeChatSubscriptionHash')
        .on('hashchange.growtypeChatSubscriptionHash', showSubscriptionModalFromHash);

    $(showSubscriptionModalFromHash);

    /**
     * On modal show — analytics + credits block (delegated so it works on dynamically injected modals)
     */
    $(document).on('show.bs.modal', '#growtypeWcSubscriptionModal', function (event) {
        if (typeof growtypeAnalyticsCapture === 'function') {
            let modal = $(this);
            setTimeout(function () {
                let modalTitle = modal.find('.modal-title').text();
                growtypeAnalyticsCapture('growtype_analytics_growtype_chat_show_subscription_modal', {
                    title: modalTitle,
                });
            }, 500);
        }

        let button = event.relatedTarget ? $(event.relatedTarget) : null;
        if (!button) return;

        let creditsBlock = $(this).find('.b-unlockwith-credits');
        let params = button.data('params');

        if (creditsBlock) {
            creditsBlock.hide();

            if (params) {
                let unlock_with_credits = params.unlock_with_credits ?? false;
                let unlockCredits = params.unlock_credits ?? null;
                let reason = params.reason ?? null;
                let feature = params.feature ?? null;

                if (unlock_with_credits) {
                    creditsBlock.show();
                    creditsBlock.find('.credits-amount').text(unlockCredits);
                    creditsBlock.find('.btn-growtype-chat-use-credits').attr('data-params', JSON.stringify({
                        credits_amount: unlockCredits,
                        reason,
                        feature,
                    }));
                }
            }
        }
    });

    /**
     * On modal fully shown — init or re-position the benefits slider.
     * Delegated on document so it fires for dynamically injected modals too.
     */
    $(document).on('shown.bs.modal', '#growtypeWcSubscriptionModal, #growtypeChatExtraCreditsModal', function () {
        const $slider = $(this).find('.growtype-theme-slider');
        const isSubscriptionModal = this.id === SUBSCRIPTION_MODAL_ID;

        if (!$slider.length || !$.fn.slick) return;

        if ($slider.hasClass('slick-initialized') && $slider[0]?.slick) {
            // Already initialized — just fix width after CSS transition completes
            $slider.slick('setPosition');
            $slider.slick('slickPlay');
            if (isSubscriptionModal) {
                syncSubscriptionSliderWithHash($slider, true);
            }
        } else if ($slider.hasClass('slick-initialized')) {
            if (isSubscriptionModal) {
                syncSubscriptionSliderWhenReady($slider, true);
            }
        } else {
            // Hide until Slick is ready to avoid flash of raw stacked slides
            $slider.hide();

            let opts = {};
            try {
                opts = JSON.parse($slider.attr('data-gslick') || '{}');
            } catch (e) { }

            $slider.one('init', function () {
                const $initializedSlider = $(this);
                if (isSubscriptionModal) {
                    syncSubscriptionSliderWhenReady($initializedSlider, true);
                } else {
                    $initializedSlider.show();
                }
            });

            $slider.slick(opts);
        }
    });

    /**
     * Extend modal AJAX data with session_token from .g-chatform
     */
    document.addEventListener('growtypeModalBeforeLoad', function (event) {
        const { trigger, extraData } = event.detail;
        const chatform = trigger ? trigger.closest('.g-chatform[data-session-token]') : null;
        if (chatform) {
            extraData.session_token = chatform.getAttribute('data-session-token');
        }
    });
}
